import React from 'react'
import NavBar from 'components/navBar'
import classNames from 'classnames'

const Layout = (props) => {
  return (
    <div>
      <header className={classNames(props.show && 'hidden')}>
        <NavBar />
      </header>

      <main className="flex gap-4 w-full">
        {props.children}
      </main>
     
    </div>
  )
}

export default Layout
